module.exports = __webpack_public_path__ + "static/media/back.f57d27a9.svg";